export function addInViewCheck(element) {

    if(!element) {
      return
    }

    // const page = document.documentElement
    const page = document.querySelector('.content-wrapper')

    const checkPos = ()=> {

      let rect = element.getBoundingClientRect()
      let inView = rect.top >= 0 && rect.left >= 0 && rect.bottom <= (page.innerHeight || page.clientHeight) + 300 && rect.right <= (page.innerWidth || page.clientWidth)

      if(inView) {
        element.classList.add('visible')
      } else {
        element.classList.remove('visible')
      }

    }

    page.addEventListener('scroll', ()=> {
      checkPos()
    })

    checkPos()
}



// WEBPACK FOOTER //
// ./src/in-view.js